/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import ControlButton from '../core/control/control-button';
import SetupRoot from '../core/setup/setup-root';
import ViewerRoot from '../core/viewer/root/viewer-root';
import template from './player-root.html';

export default {
  name: 'PlayerRoot',
  template,
  components: { SetupRoot, ViewerRoot },
  created() {
    // Naslouchání událostem.
    const { controlManager } = this.$root;
    controlManager.on('buttonDown', this.onButtonDown);
    // Aktualizace, jaký modul zobrazovat.
    this.refresh();
  },
  data() {
    return {
      setupVisible: false,
      viewerVisible: false
    };
  },
  destroyed() {
    // Zrušení naslouchání událostem.
    const { controlManager } = this.$root;
    controlManager.off('buttonDown', this.onButtonDown);
  },
  methods: {
    back() {
      if (this.setupVisible) {
        // Setup spravuje tlačítko zpět samostatně.
        return;
      }
      this.$root.appManager.exit();
    },
    handleError(error) {
      this.$root.logger.error(error);
    },
    onButtonDown(controlButton) {
      if (controlButton === ControlButton.Back) {
        this.back();
      }
    },
    onError(error) {
      this.handleError(error);
    },
    onSetupFinish() {
      this.refresh();
    },
    refresh() {
      const installed = this.$root.session.isInstalled();
      this.setupVisible = !installed;
      this.viewerVisible = installed;
    }
  }
};
